import * as createXLComplaintTypes from '../types/CreateXLComplaint';

export function setXLComplaintParams(params) {
    return (dispatch) => {
        return dispatch({
            type: createXLComplaintTypes.SET_XL_COMPLAINT_PARAMS,
            params
        });
    };
}


// WEBPACK FOOTER //
// ./src/actions/CreateXLComplaint.js